/* eslint-disable */
export const settings = {
  APP_NAME: 'Ambee',
  API_SERVER: 'https://device-admin-backend.ambeedata.com/',  
  // API_SERVER: 'http://localhost:5000/',
};
